import {http} from '@/plugins/http';

export default {

    /**
     * @param {string} contactKey
     *
     * @returns {AxiosPromise | *}
     */
    index(contactKey) {
        return http.get(`/api/v1/contacts/${contactKey}/settings`);
    },

    /**
     * @param {string} contactKey
     * @param {string} settingKey
     *
     * @returns {AxiosPromise | *}
     */
    show(contactKey, settingKey) {
        return http.get(`/api/v1/contacts/${contactKey}/settings/${settingKey}`);
    },

    /**
     * @param {string} contactKey
     * @param {string} key
     * @param {*} value
     *
     * @returns {AxiosPromise | *}
     */
    save(contactKey, key, value) {
        return http.post(`/api/v1/contacts/${contactKey}/settings`, {
            key: key,
            value: value
        });
    },

    /**
     * @param {string} contactKey
     * @param {Object} params
     * @returns {*|AxiosPromise}
     */
    saveSettings(contactKey, params) {
        return http.post(`/api/v1/contacts/${contactKey}/settings/save-settings`, params);
    },

    /**
     * @param {string} contactKey
     * @param {Object} params
     * @returns {*|AxiosPromise}
     */
    saveStatusInformationSettings(contactKey, params) {
        return http.post(`/api/v1/contacts/${contactKey}/settings/save-status-information-settings`, params);
    }

};



// WEBPACK FOOTER //
// ./src/services/Contacts/SettingsController.js